import { Entity } from 'siren-parser';

export interface SubscriptionEntity extends Entity {
  properties: {
    threshold: number,
    type: string,
    entityType: string,
    deliveryModes: { [index:string] : boolean },
  },
}

export interface SubscriptionTypeDetails {
  type: string,
  title?: string, // TODO: This should be deprecated and replaced by a translation key generated in the format: `notificationTypeDetails.${type}.title`
  threshold?: { units: string, default: number },
  hasInfoDialog?: boolean,
}

export const subscriptionTypeDetails = {
  orderApprovalPending: { type: 'orderApprovalPending' },
  lateOrder: { type: 'lateOrder' },
  orderRequestReady: { type: 'orderRequestReady' },

  feedOutage: {
    type: 'feedOutage',
    hasInfoDialog: true,
    threshold: { units: 'hours', default: 8 },
  },
  slideManagementIssue: {
    type: 'slideManagementIssue',
    hasInfoDialog: true,
    threshold: { units: 'hours', default: 8 },
  },
  barnEmptyAtThreshold: { type: 'barnEmptyAtThreshold', threshold: { units: 'days', default: 2 } },
  barnFeedFlatline: { type: 'barnFeedFlatline', threshold: { units: 'hours', default: 8 } },
  multipleSlidesOpen: { type: 'multipleSlidesOpen', threshold: { units: 'hours', default: 8 } },
  consumptionDeviation: { type: 'consumptionDeviation', threshold: { units: 'percent', default: 8 } },

  binConsumptionThreshold: { type: 'binConsumptionThreshold', threshold: { units: 'hours', default: 8 } },
  binPercentThreshold: { type: 'binPercentThreshold', threshold:{ units: 'percent', default: 5 } },
  binEmptyAtThreshold: { type: 'binEmptyAtThreshold', threshold:{ units: 'days', default: 1 } },
  binUnreliableData: { type: 'binUnreliableData' },
};

export const subscriptionGroups = {
  orders: {
    types: new Map([
      subscriptionTypeDetails['orderApprovalPending'],
      subscriptionTypeDetails['lateOrder'],
      subscriptionTypeDetails['orderRequestReady'],
    ].map(type => [type.type, type])),
  },
  barns: {
    notificationsSnoozable: true,
    types: new Map([
      subscriptionTypeDetails['feedOutage'],
      subscriptionTypeDetails['slideManagementIssue'],
      subscriptionTypeDetails['barnEmptyAtThreshold'],
      subscriptionTypeDetails['barnFeedFlatline'],
      subscriptionTypeDetails['multipleSlidesOpen'],
      subscriptionTypeDetails['consumptionDeviation'],
    ].map(type => [type.type, type])),
  },
  bins: {
    notificationsSnoozable: true,
    types: new Map([
      subscriptionTypeDetails['binConsumptionThreshold'],
      subscriptionTypeDetails['binPercentThreshold'],
      subscriptionTypeDetails['binEmptyAtThreshold'],
    ].map(type => [type.type, type])),
  },
  data: {
    types: new Map([
      subscriptionTypeDetails['binUnreliableData'],
    ].map(type => [type.type, type])),
  },
};
